import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setCredentials, logOut } from "../../features/auth/authSlice";
import { showToast } from "../uiSlice";
import { auth } from "../../firebase";

// export const baseUrl = "https://apple-project-api.akaai.io"
// export const baseUrl = "http://127.0.0.1:8000"
// export const baseUrl = "http://desktop.lan:8000"
// The API follows the host the bundle is served from, so one build can be promoted from
// staging to prod unchanged (#289). Any other host (localhost, web-dev, the raw cloudfront.net
// name) uses the build-time REACT_APP_API_BASE_URL. Add the staging host here when it exists.
const API_BY_HOST = {
  "theaceacademy.ai": "https://api.theaceacademy.ai",
  "www.theaceacademy.ai": "https://api.theaceacademy.ai",
};
export const baseUrl = API_BY_HOST[window.location.hostname] || process.env.REACT_APP_API_BASE_URL

// Browsers cannot set an Authorization header on a WebSocket handshake, so
// the backend accepts the bearer token as a ?token= query parameter instead.
// Read from localStorage at call time (kept fresh by setCredentials) so
// reconnects pick up refreshed tokens. Harmless against older backends,
// which simply ignore the parameter.
export const withWsToken = (url) => {
  const token = localStorage.getItem("token");
  if (!token) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}token=${encodeURIComponent(token)}`;
};

const baseQuery = fetchBaseQuery({
  baseUrl: baseUrl,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error) {
    console.log('API Error:', result.error);
  }

  const status = result?.error?.status ?? result?.error?.originalStatus;

  if (status === 403) {
    api.dispatch(showToast({
      title: '접근 권한 없음',
      message: '이 작업을 수행할 권한이 없습니다.',
      type: 'error',
    }));
    return result;
  }

  if (status === 401) {
    console.log("sending refresh token");

    if (auth.currentUser) {
      try {
        const token = await auth.currentUser.getIdToken(true);
        const { user, username, partner } = api.getState().auth;
        api.dispatch(setCredentials({ access: token, user, username, partner }));
        result = await baseQuery(args, api, extraOptions);
        return result;
      } catch (error) {
        console.error("Firebase token refresh failed:", error);
        api.dispatch(logOut());
        return result;
      }
    }

    const refreshToken = api.getState().auth.refreshToken;
    if (!refreshToken) {
      console.error("No refresh token available");
      api.dispatch(logOut());
      return result;
    }
    const refreshResult = await baseQuery(
      {
        url: "/auth/token/refresh/",
        method: "POST",
        body: { refresh: refreshToken }
      },
      api,
      extraOptions
    );
    console.log(refreshResult);
    if (refreshResult?.data) {
      const user = api.getState().auth.user;
      api.dispatch(setCredentials({ ...refreshResult.data, user }));
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logOut());
    }
  }

  if (result?.error) {
    const finalStatus = result.error.status ?? result.error.originalStatus;
    if (finalStatus !== 401) {
      api.dispatch(showToast({
        title: '데이터를 불러오는 중 오류가 발생했습니다',
        message: result.error?.data?.detail || '잠시 후 다시 시도해 주세요.',
        type: 'warning',
      }));
    }
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  tagTypes: ["SupportTicket"],
  endpoints: (builder) => ({}),
});
